import { useState } from "react";
import { LineChart } from "../../common/LineChart";
import {
  AccountantStat,
  IAccountCardStat,
} from "../../stats/subs/accountantState";
import {
  accountStat,
  getRestockingTableData,
  getSalesTableData,
  lineChartData,
  lineChartOptions,
  restockingTableHeaders,
  restockingTableKeys,
  salesTableHeaders,
  salesTableKeys,
} from "../data";
import { MonthSaleWrapper, RevealData } from "../style";
import { DRFCrumb } from "@/common/components/drf-breadcrumb";
import { BiChevronDown } from "react-icons/bi";
import Table from "@/common/components/Table";

const ViewMonthSale = () => {
  const [active, setActive] = useState<null | string>(null);
  const tableReveal = {
    active: "Sales Transaction",
    revealData: [
      {
        title: "Sales Transaction",
        data: (
          <Table
            tableData={getSalesTableData()}
            tableHeaders={salesTableHeaders}
            tableKeys={salesTableKeys}
          />
        ),
      },
      {
        title: "Restocking Transaction",
        data: (
          <Table
            tableData={getRestockingTableData()}
            tableHeaders={restockingTableHeaders}
            tableKeys={restockingTableKeys}
          />
        ),
      },
    ],
  };
  return (
    <MonthSaleWrapper active={active as string}>
      <DRFCrumb
        currentPage="Monthly Sale"
        previousPage="Dashboard"
        previousPageLink="/dashboard/accountant/financials"
      />
      <div className="card-wrapper">
        {accountStat?.map((accountData: IAccountCardStat) => (
          <AccountantStat {...accountData} />
        ))}
      </div>
      <div className="chart-wrapper">
        <LineChart
          first=""
          second=""
          title="Weekly Sales Trend"
          chartData={lineChartData}
          options={lineChartOptions}
          height={400}
        />
      </div>
      {tableReveal.revealData?.map((data: any) => (
        <RevealData
          key={data.title}
          active={active}
          title={data.title}
          iconSize="2rem"
          contentBg="#f9f9f9"
        >
          <div
            onClick={() => setActive(data.title === active ? null : data.title)}
            className="reveal-content"
          >
            <h1>{data?.title}</h1>
            <BiChevronDown className="reveal-icon" />
          </div>
          {active === data.title && <div>{data?.data}</div>}
        </RevealData>
      ))}
    </MonthSaleWrapper>
  );
};

export default ViewMonthSale;
